/**
 * Faceted Search - Async
 */

(() => {
    let form = document.querySelector('.js-faceted-search-form');
    let submit_button = document.querySelector(
        '.js-faceted-search-submit-button'
    );

    if (!form || !submit_button) {
        return;
    }

    function hideOverlay() {
        // console.log('Hiding overlay...');
        document
            .querySelector('.js-faceted-search-results-overlay')
            ?.classList.add('-hidden');
    }

    function showOverlay() {
        // console.log('Showing overlay...');
        document
            .querySelector('.js-faceted-search-results-overlay')
            ?.classList.remove('-hidden');
    }

    function setHistory() {
        // console.log('Setting history...');

        const formData = new FormData(form);
        let search = new URLSearchParams(formData);
        search.delete('override-page'); // remove override-page -parameter
        const query = search.toString();
        const url = '?' + query;

        // console.log('url', url);

        window.history.replaceState(null, '', url);
    }

    function isEventForLoadMoreButton(e) {
        return e.target.classList.contains(
            'js-htmx-faceted-search-load-more-button'
        );
    }

    form.addEventListener('htmx:beforeRequest', (e) => {
        if (isEventForLoadMoreButton(e)) {
            return;
        }

        showOverlay();

        form.querySelector('#search-results').classList.add('-invalid');
    });

    form.addEventListener('htmx:afterOnLoad', (e) => {
        if (isEventForLoadMoreButton(e)) {
            return;
        }

        let results = document.querySelector('#search-results');

        // Make loaded search results backwards focusable
        H_Tools?.stickyheader?.makeBackwardsFocusable(results);

        // Enable dictionary entries in loaded search results
        H_Tools?.dictionary?.enableDictionaryEntries(results);

        setHistory();
        hideOverlay();
    });
})();
